import { getTestIds } from 'seagull/utils/TestIds';
export const GetNotificationEmailPreviewTID = (parentTestId)=>getTestIds(parentTestId);
